import React, { memo } from 'react';
import '../../../../components/centerModal/css/centerModal.scss';
import { Modal, Form, FloatingLabel } from 'react-bootstrap';
const NameModal = ({ show, onHide, value, setValue, submitClick }) => {
  return (
    <Modal className="centerModal" size="md" centered show={show} onHide={onHide} >
      <Modal.Header className="position-relative border-0 p-4 mb-1">
        <Modal.Title className="fs-4 text-black fw-semibold">
          User Name<span className="text-danger">*</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <form>
          <div className="w-100 centerModalFrm">
            <div className="row mt-n4">
              <FloatingLabel className="mt-4 px-0" controlId="floatingInput" label="Your Name">
                <Form.Control
                  className="fs-4 userProfile_nameModal_yourName"
                  type="text"
                  placeholder="Your Name"
                  value={value}
                  onChange={setValue}
                />
              </FloatingLabel>
              <div className="mt-4 d-flex flex-wrap centerModalBttns px-0">
                <button
                  className="col fs-4 btn btn-danger py-3 px-4 userProfile_nameModal_cancel"
                  type="button"
                  onClick={onHide}
                  aria-label="Cancel"
                >
                  Cancel
                </button>
                <button
                  className="col fs-4 btn btn-primary py-3 px-4 userProfile_nameModal_submit"
                  type="button"
                  onClick={submitClick}
                  aria-label="Submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default memo(NameModal);
